import createReducer from '../lib/createReducer';
import * as types from '../actions/types';
import { migrateToWeave } from '../actions/carriers';

export const carriers = createReducer(
  {
    buyingPhoneNumber: false,
    buyPhoneNumberSuccess: false,
    migrateToWeaveInProgress: false,
    migrateToWeaveSuccess: false,
    updateWeaveInProgress: false,
    updateWeaveSuccess: false,
    migrateError: '',
    weaveInfo: {},
    errorMessage: '',
    updateWeaveError: '',
    newPhoneNumber: '',
    fetchEligibleForFusionMigrationInProgress: false,
    eligible_for_fusion_migration: false,
  },
  {
    [types.GET_TEXT_NUMBER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        phoneNumber: action.textNumber,
      });

      return newState;
    },
    [types.GET_TEXT_NUMBER_FAIL](state) {
      const newState = Object.assign({}, state, {
        phoneNumber: null,
      });

      return newState;
    },
    [types.TEXT_CALLFORWARD_START](state, action) {
      const newState = Object.assign({}, state, {
        callForwardRequest: action.req,
        isCallForwardVericationInProgress: true,
        isCallForwardVerify: false,
        callForwardVerifyStatus: '',
      });

      return newState;
    },
    [types.TEXT_CALLFORWARD_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        callForwardRequest: null,
        isCallForwardVericationInProgress: false,
        isCallForwardVerify: true,
        callForwardVerifyStatus: 'success',
      });

      return newState;
    },
    [types.TEXT_CALLFORWARD_FAIL](state) {
      const newState = Object.assign({}, state, {
        callForwardRequest: null,
        isCallForwardVericationInProgress: false,
        isCallForwardVerify: false,
        callForwardVerifyStatus: 'error',
      });

      return newState;
    },
    [types.GET_NEW_PHONE_NUMBER_START](state, action) {
      const newState = Object.assign({}, state, {
        buyingPhoneNumber: true,
        errorMessage: '',
      });
      return newState;
    },
    [types.GET_NEW_PHONE_NUMBER_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        buyingPhoneNumber: false,
        buyPhoneNumberSuccess: true,
        newPhoneNumber: action.newPhoneNumber,
        errorMessage: '',
      });
      return newState;
    },
    [types.GET_NEW_PHONE_NUMBER_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        buyingPhoneNumber: false,
        buyPhoneNumberSuccess: false,
        errorMessage: action.errorMessage,
      });
      return newState;
    },
    [types.GET_NEW_PHONE_NUMBER_CLEAR](state, action) {
      const newState = Object.assign({}, state, {
        errorMessage: '',
        migrateError: '',
        updateWeaveError: '',
        updateWeaveSuccess: false,
      });
      return newState;
    },

    [types.MIGRATE_TO_WEAVE_START](state, action) {
      const newState = Object.assign({}, state, {
        migrateToWeaveInProgress: true,
        migrateError: '',
      });
      return newState;
    },
    [types.MIGRATE_TO_WEAVE_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        migrateToWeaveInProgress: false,
        migrateToWeaveSuccess: true,
        migrateError: '',
      });
      return newState;
    },
    [types.MIGRATE_TO_WEAVE_FAIL](state, action) {
      console.log('action.message', action);
      const newState = Object.assign({}, state, {
        migrateToWeaveInProgress: false,
        migrateToWeaveSuccess: false,
        migrateError: action?.data?.message,
      });
      return newState;
    },

    [types.UPDATE_WEAVE_INFO_START](state, action) {
      const newState = Object.assign({}, state, {
        updateWeaveInProgress: true,
      });
      return newState;
    },
    [types.UPDATE_WEAVE_INFO_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        updateWeaveInProgress: false,
        updateWeaveSuccess: true,
        weaveInfo: action.data,
      });
      return newState;
    },
    [types.UPDATE_WEAVE_INFO_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        updateWeaveInProgress: false,
        updateWeaveSuccess: false,
        updateWeaveError: action?.data?.message,
      });
      return newState;
    },

    [types.CAN_MIGRATE_TO_WEAVE_START](state, action) {
      const newState = Object.assign({}, state, {
        fetchEligibleForFusionMigrationInProgress: true,
      });
      return newState;
    },
    [types.CAN_MIGRATE_TO_WEAVE_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        fetchEligibleForFusionMigrationInProgress: false,
        eligible_for_fusion_migration: action?.data?.eligible_for_fusion_migration,
      });
      return newState;
    },
    [types.CAN_MIGRATE_TO_WEAVE_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        fetchEligibleForFusionMigrationInProgress: false,
      });
      return newState;
    },

  },
);

export { carriers as default };
